/**
 * IllustratedEmptyState — empty table/list callout with icon well and copy.
 */
import { Typography } from "../../atoms/Typography";
import { IconWrapper } from "../../atoms/IconWrapper";
import { cn } from "@/utils/cn";
import type { IllustratedEmptyStateProps } from "./IllustratedEmptyState.types";
import {
  illustratedEmptyStateIconWellClass,
  illustratedEmptyStateRootClass,
} from "./IllustratedEmptyState.styles";

export type { IllustratedEmptyStateProps } from "./IllustratedEmptyState.types";

export function IllustratedEmptyState({
  icon,
  title,
  description,
  className,
}: IllustratedEmptyStateProps) {
  return (
    <div className={cn(illustratedEmptyStateRootClass, className)}>
      <div className={illustratedEmptyStateIconWellClass}>
        <IconWrapper size="md" color="purple">
          {icon}
        </IconWrapper>
      </div>
      <Typography variant="h3" weight="bold" color="primary">
        {title}
      </Typography>
      <Typography variant="body-sm" color="secondary" className="max-w-md">
        {description}
      </Typography>
    </div>
  );
}
